import React from "react";
import styles from "../style/SendEmailModal.module.css"

const ContractTypeBadge = ({ contractType, additionalStyle }) => {
  if (!contractType) return null;

  let label = "";
  if (contractType.startsWith("CB_")) label = "CB";
  else if (contractType.startsWith("FJGG_")) label = "FJGG";
  else if (contractType.startsWith("DC_")) label = "COX";
  else return null;

  return (
    <span className={styles.contractTypeBadge} style={additionalStyle}>
      {label}
    </span>
  );
};

export default ContractTypeBadge;
